export default "__VITE_ASSET__zX_LysgZ__"